import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

export const reportUserMutation = gql`
  mutation reportUser($input: ReportUserInput!) {
    reportUser(input: $input)
  }
`;

const reportUserOptions = {
  props: ({ mutate }) => ({
    reportUser: input =>
      mutate({
        variables: {
          input,
        },
      }),
  }),
};

export default graphql(reportUserMutation, reportUserOptions);
